/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Reply_CheckInputs */



/**
* | output |
* | --- |
* | "Reply Check" |
*
* @param {Metadata_Merge_Reply_CheckInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_reply_check = /** @type {((inputs?: Metadata_Merge_Reply_CheckInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Reply_CheckInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vérification de la réponse")
	if (locale === "de") return /** @type {LocalizedString} */ ("Antwort geprüft")
	if (locale === "it") return /** @type {LocalizedString} */ ("Controllo risposta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проверка ответа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comprobación de respuesta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("回复检查")
	if (locale === "ja") return /** @type {LocalizedString} */ ("返信確認")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उत्तर जाँच")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verificação de resposta")
	return /** @type {LocalizedString} */ ("Reply Check")
});